import IconButton from "@material-ui/core/IconButton";
import LogoutIcon from "@material-ui/icons/ExitToApp";
import axios from "axios";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { UserContext } from "../contexts";
import { User } from "../types";

const LogoutButton: React.FC = () => {
  const [, setUser] = useContext(UserContext);

  const [pending, setPending] = useState(false);
  const [loading, setLoading] = useState(false);
  const [, setError] = useState<any>();

  const handleLogout = useCallback(() => {
    setPending(true);
  }, []);

  useEffect(() => {
    async function logout(): Promise<void> {
      if (pending && !loading) {
        setLoading(true);
        try {
          await axios.post<User>("/session/delete/");
          setUser(undefined);
        } catch (err) {
          setError(err);
        } finally {
          setPending(false);
          setLoading(false);
        }
      }
    }
    void logout();
  }, [pending, loading, setUser]);

  const disabled = pending || loading;

  return (
    <IconButton color="inherit" aria-label="logout" onClick={handleLogout} disabled={disabled}>
      <LogoutIcon />
    </IconButton>
  );
};

export default LogoutButton;
